const users = {
  granted: 'Accordée',
  notGranted: 'Non accordée',
  noUsersToDisplay: 'Aucun utilisateur à afficher',
  permissionFeaturesManage: 'Gérer les fonctionnalités',
  permissions: 'Permissions',
  permissionUsersList: 'Lister les utilisateurs',
  user: 'Utilisateur',
  users: 'Utilisateurs',
};

export default users;
